import PropTypes from 'prop-types';
import React from 'react';
import { Typography } from '@sm/wds-react';
import { ComparisonTableFooterCell } from '~pricing/components/ComparisonTable';
import { packageLabelToClassName } from '~pricing/lib/helpers';
import { PackagePropTypes, PackageComparisonPropTypes } from '~pricing/lib/proptypes';

const SummaryComparisonTableFooter = ({ pricingPackage, packageTableDetails }) => {
  const { ctaRenderer: CtaRenderer } = packageTableDetails;
  return (
    <ComparisonTableFooterCell>
      <Typography
        variant="cardTitle"
        component="h4"
        className="wds-p-b-3"
        data-testid="SummaryComparisonTableFooter__Label"
      >
        {pricingPackage.details.label}
      </Typography>
      <CtaRenderer
        packageName={pricingPackage.package}
        packageClassName={packageLabelToClassName(pricingPackage.details)}
        small
      />
    </ComparisonTableFooterCell>
  );
};

SummaryComparisonTableFooter.propTypes = {
  pricingPackage: PropTypes.shape(PackagePropTypes).isRequired,
  packageTableDetails: PropTypes.shape(PackageComparisonPropTypes).isRequired,
};

export default SummaryComparisonTableFooter;
